// import external dependencies
import "jquery";

// Import everything from autoload
import "./autoload/_bootstrap.js";

// Custom Event polyfill
import "custom-event-polyfill/polyfill";

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import singleProduct from "./routes/single-product";
import woocommerceCart from "./routes/cart";

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  singleProduct,
  // Cart
  woocommerceCart,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js